const DEFAULT_GRID_BOUNDS = {
  minX: -800,
  minY: -800,
  maxX: 800,
  maxY: 800,
  width: 3200,
  height: 3200,
};

export default function getGridBounds({ isFocusMode, focusContentBounds, contentBounds }) {
  if (isFocusMode && focusContentBounds) return focusContentBounds;
  if (contentBounds) return contentBounds;
  return DEFAULT_GRID_BOUNDS;
}
